import global from '../global'

export default {
    bgcolor: 'error.light',
    color: 'error.contrastText',
    fontSize: 'body2.fontSize',
    padding: global.subCard.padding,
}